<template>
<div>
    <div class="mt-2">
        <v-btn text @click="$router.push(goTo)">
            <v-icon size="14px" color="grey darken-3" class="mr-3">fa-angle-left</v-icon>
            <span v-if="ct">Back to center</span>
            <span v-else>Back to groups</span>
        </v-btn>
    </div>

    <v-row v-if="loaded">
        <v-col cols="12" sm="7">
            <v-card flat outlined>
                <v-card-text>
                    <div class="title accent--text">Create new group</div>

                    <v-select
                        v-if="user.role.master"
                        class="mt-3"
                        v-model="model.center"
                        :items="centers"
                        item-text="name"
                        item-value="id"
                        append-icon="fa-angle-down primary--text"
                        label="Select center">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-store-alt fa-fw</v-icon>
                        </template>
                    </v-select>

                    <div class="d-flex align-center mt-3" v-if="user.role.director">
                        <v-icon small class="mr-3" color="info">fa-store-alt</v-icon>
                        <div class="subtitle-1">{{centerName}} Center</div>
                    </div>

                    <v-text-field
                        class="mt-4"
                        v-model="model.reference"
                        label="Reference year"
                        maxlength="40"
                        hint="Generation" persistent-hint
                        @keydown.enter="validate">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-tag fa-fw</v-icon>
                        </template>
                    </v-text-field>

                    <v-select
                        class="mt-3"
                        v-model="model.day"
                        :items="days"
                        append-icon="fa-angle-down primary--text"
                        label="Select day">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-calendar-day fa-fw</v-icon>
                        </template>
                    </v-select>

                    <!-- <v-text-field
                        class="mt-4"
                        v-model="model.day"
                        label="Day"
                        maxlength="40"
                        @keydown.enter="validate"
                        hide-details>
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-calendar fa-fw</v-icon>
                        </template>
                    </v-text-field> -->

                    <!-- <v-text-field
                        class="mt-6"
                        v-model="model.hour"
                        label="Hour"
                        maxlength="40"
                        @keydown.enter="validate"
                        hide-details>
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-hourglass fa-fw</v-icon>
                        </template>
                    </v-text-field> -->
                    
                    <div class="ml-8">
                        <div class="grey--text text--darken-2 subtitle-1">Select time</div>
                        <v-time-picker v-model="model.hour" ampm-in-title format="ampm" header-color="primary"></v-time-picker>
                    </div>

                    <div class="text-end mt-10">
                        <v-btn 
                            depressed 
                            large
                            class="accent" 
                            @click="validate" 
                            :disabled="sending">Add group</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Groups from '@/firebase/groups'
import Centers from '@/firebase/centers'
import Schedules from '@/firebase/schedules'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        model: {
            center: '',
            day: '',
            hour: '',
            reference: ''
        },
        days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'], 
        centerName: '',
        centers: [],
        ct: null
    }),
    computed: {
        goTo() {
            if (this.ct) {
                return '/admin-center/'+this.ct;
            } else {
                if (this.user.role.director) {
                    return '/admin-groups-center';
                } else {
                    return '/admin-groups';
                }
            }
        }
    },
    mounted() {
        this.getParams();
        this.init();
    },
    methods: {
        getParams() {
            let url = new URL(window.location.href);
            this.ct = url.searchParams.get('ct');
            if (this.ct != undefined) {
                this.model.center = this.ct;
            }
        },
        init() {
            Centers.getAll()
                    .then(response => {
                        if (response.status === true) {
                            this.centers = Helpers.formatItems(response.query);
                            if (this.user.role.director) {
                                this.centerName = this.getCenter(this.user.center).name;
                            }
                            
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        getCenter(id) {
            let tempo;
            this.centers.forEach(dt => {
                if (dt.id == id) {
                    tempo = dt;
                }
            });

            this.model.center = id;

            return tempo;
        },
        validate() {
    		if (this.validateIsEmpty(this.model.center)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a center.'});
                return;
            }

            if (this.validateIsEmpty(this.model.day)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a day.'});
                return;
            }

            if (this.validateIsEmpty(this.model.hour)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set an hour.'});
                return;
            }

            if (this.validateIsEmpty(this.model.reference)) {
    			window.scrollTo(0, 0);
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a reference.'});
                return;
            }

            this.prepare();
        },
        prepare() {
            let final = JSON.parse(JSON.stringify(this.model));

            let c = _.find(this.centers, center => {return center.id == final.center})
            final.center = {
                id: c.id,
                name: c.name
            }

            let h = final.hour.substr(0,2);

            if (h == '00') {
                final.hour = '12' + final.hour.substr(2,3)  + ' am';
            } else if (h == '12') {
                final.hour = '12' + final.hour.substr(2,3)  + ' pm';
            } else if (h > 11) {
                let num = Number(final.hour.substr(0,2));
                num -= 12;
                final.hour = num + final.hour.substr(2,3)  + ' pm';
            } else {    
                final.hour += ' am';
            }

           this.add(final)
        },
        add(final) {
            this.sending = true;

            Groups.add(final)
                    .then(response => {
                        if (response === true) {
                            if (this.user.role.master) {
                                this.$router.push('/admin-groups');
                            } else {
                                this.$router.push('/admin-groups-center');
                            }

                            this.$store.dispatch('setSnack', {kind:'success', text:'A group has added.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>